var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('accept-terms'),_c('organization-dropdown'),_c('menu-component'),_c('dashboard-content'),_c('footer-component',{attrs:{"absolute":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }